import * as yup from 'yup';

export const latestReadingSchema = yup.object({
  account: yup.object({
    properties: yup.array(
      yup.object({
        activeWaterMeters: yup.array(
          yup.object({
            readings: yup.object({
              edges: yup.array(
                yup.object({
                  node: yup.object({
                    id: yup.string().required(),
                  }),
                })
              ),
            }),
          })
        ),
      })
    ),
  }),
});

export const meterReadingsSchema = yup.object({
  account: yup.object({
    properties: yup.array(
      yup.object({
        activeWaterMeters: yup.array(
          yup.object({
            readings: yup.object({
              id: yup.string(),
              numberOfDigits: yup.number(),
              edges: yup.array(
                yup.object({
                  node: yup.object({
                    readingDate: yup.date(),
                    valueCubicMetres: yup.number(),
                    source: yup.string(),
                  }),
                })
              ),
            }),
          })
        ),
      })
    ),
  }),
});

export const submitMeterReadingSchema = yup.object({
  submitMeterReading: yup.object({
    reading: yup.object({
      id: yup.string().required(),
      valueCubicMetres: yup.number().required(),
      isHeld: yup.boolean().required(),
      possibleErrors: yup.array(
        yup.object({
          message: yup.string(),
        })
      ),
    }),
    possibleErrors: yup.array(
      yup.object({
        message: yup.string(),
      })
    ),
  }),
});

export const meterDetailsSchema = yup.object({
  account: yup.object({
    properties: yup.array(
      yup.object({
        activeWaterMeters: yup.array(
          yup.object({
            serialNumber: yup.string().required(),
            numberOfDigits: yup.number().required(),
            readings: yup.object({
              edges: yup.array(
                yup.object({
                  node: yup.object({
                    readingDate: yup.date(),
                    valueCubicMetres: yup.number(),
                    source: yup.string(),
                  }),
                })
              ),
            }),
          })
        ),
      })
    ),
  }),
});

export const meterReadingSuccessSchema = yup.object({
  account: yup.object({
    properties: yup.array(
      yup.object({
        activeWaterMeters: yup.array(
          yup.object({
            numberOfDigits: yup.number().required(),
            readings: yup.object({
              edges: yup.array(
                yup.object({
                  node: yup.object({
                    valueCubicMetres: yup.number(),
                  }),
                })
              ),
            }),
          })
        ),
      })
    ),
  }),
});

export const hasActiveWaterMeterSchema = yup.object({
  account: yup.object({
    properties: yup.array(
      yup.object({
        activeWaterMeters: yup.array(
          yup.object({
            id: yup.string(),
          })
        ),
      })
    ),
  }),
});

export const isOnMeasuredTariffSchema = yup.object({
  account: yup.object({
    isMeasured: yup.boolean().nullable(),
  }),
});

export const meterFittingAppointmentSchema = yup.object({
  account: yup
    .object({
      properties: yup
        .array(
          yup.object({
            serviceOrders: yup.object({
              edges: yup.array(
                yup.object({
                  node: yup.object({
                    scheduledAt: yup.string().nullable(),
                    scheduledEndAt: yup.string().nullable(),
                    jobName: yup.string().nullable(),
                  }),
                })
              ),
            }),
          })
        )
        .required(),
    })
    .required(),
});

export const canSwitchToMeasuredTariffSchema = yup.object({
  account: yup
    .object({
      potentialSwitchToMeasured: yup
        .object({
          canSwitch: yup.boolean().required(),
        })
        .required(),
    })
    .required(),
});

export const switchToMeasuredPaymentScheduleSchema = yup.object({
  account: yup
    .object({
      potentialSwitchToMeasured: yup
        .object({
          isVariablePaymentAmount: yup.boolean().nullable(),
          paymentAmount: yup.number().nullable(),
        })
        .required(),
    })
    .required(),
});

export const switchAccountToMeasuredTariffSchema = yup.object({
  switchAccountToMeasuredTariff: yup.object({
    account: yup.object({
      isMeasured: yup.bool().required(),
    }),
  }),
});

export const getMeterIdentifiersSchema = yup.object({
  account: yup.object({
    properties: yup
      .array(
        yup.object({
          activeWaterMeters: yup
            .array(
              yup.object({
                meterPointReference: yup.string().required(),
                serialNumber: yup.string().required(),
              })
            )
            .required(),
        })
      )
      .required(),
  }),
});

export const smartMeterReadingSchema = yup.object({
  account: yup.object({
    properties: yup
      .array(
        yup.object({
          activeWaterMeters: yup
            .array(
              yup.object({
                capabilityType: yup.string().required(),
              })
            )
            .required(),
          measurements: yup.object({
            edges: yup
              .array(
                yup.object({
                  node: yup.object({
                    startAt: yup.string().required(),
                    endAt: yup.string().required(),
                    value: yup.number().required(),
                    unit: yup.string().required(),
                    readAt: yup.string().required(),
                  }),
                })
              )
              .required(),
          }),
        })
      )
      .required(),
  }),
});
